import CompLayout from "@/pcomponents/comp/layout/layout";
import TextBookListArea from "@/pages/comp/book_order/textbook/common/list";

function TextBookListPage() {
  return (
    <CompLayout isConTitle={false}>
      <TextBookListArea></TextBookListArea>
    </CompLayout>
  );
};
export default TextBookListPage;